import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormPyramide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFormPyramide"><Path fillRule="evenodd" clipRule="evenodd" d="M23.3965 16.375L12.335 21.9209L11.999 22.0889L11.6631 21.9209L0.601562 16.375L11.999 1.51758L23.3965 16.375ZM11.9844 4H11.999V20.4102L21.1016 15.8467L11.999 3.98047L11.9844 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormPyramide;
